import { render, staticRenderFns } from "./KT-CustomField.vue?vue&type=template&id=a59d6178&lang=pug&"
import script from "./KT-CustomField.vue?vue&type=script&lang=js&"
export * from "./KT-CustomField.vue?vue&type=script&lang=js&"
import style0 from "./KT-CustomField.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports